var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('v-main',{staticStyle:{"background-image":"url('/images/background.jpg')","background-repeat":"no-repeat","background-size":"cover","background-position":"center"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }